import * as THREE from 'three';
export default class DefaultPerspectiveCamera extends THREE.PerspectiveCamera {
    constructor(engine) {
        super(75, engine.info.sizes.width / engine.info.sizes.height, 0.1, 100);
    }
}
